import { render, staticRenderFns } from "./CampaignDonutChart.vue?vue&type=template&id=19fd922c&scoped=true"
import script from "./CampaignDonutChart.vue?vue&type=script&lang=js"
export * from "./CampaignDonutChart.vue?vue&type=script&lang=js"
import style0 from "./CampaignDonutChart.vue?vue&type=style&index=0&id=19fd922c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd922c",
  null
  
)

export default component.exports